<mat-card>
<form [formGroup]=""> <div fxLayout="column" fxLayoutGap="20px">
      <div *ngIf="profile?.userId" fxLayout="row" fxLayoutGap="15px">
        <button [disabled]="!((userPermissions | async)?.note?.admin_root || noteObject?.createdBy?.uuid === profile?.userId)"
                (click)="modify()" mat-stroked-button color="primary">
          <mat-icon>create</mat-icon> <span> Edytuj</span>
        </button>
        <button [disabled]="!((userPermissions | async)?.note?.admin_root || noteObject?.createdBy?.uuid === profile?.userId)"
                (click)="delete()" mat-stroked-button color="warn">
          <mat-icon>delete</mat-icon> <span> Usuń</span>
        </button>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

          <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

              <mat-card>
                <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
                  <h3>Dane</h3>
                  <app-detail header="Rodzaj" [value]="noteObject?.typeOfMeeting?.name"></app-detail>
                  <div fxLayout="row" fxLayoutGap="20px">
                    <app-detail header="Data" [value]="noteObject?.meetingDateTime | date: 'yyyy-MM-dd HH:mm':'UTC'"></app-detail>
                    <app-detail *ngIf="noteObject?.meetingEndDate" header="Data do" [value]="noteObject?.meetingEndDate | date: 'yyyy-MM-dd'"></app-detail>
                  </div>
                  <app-detail *ngIf="noteObject?.ofwca?.fullName" header="OFWCA" [value]="noteObject?.ofwca?.fullName" [link]="['/ofwca/szczegoly', noteObject?.ofwca?.uuid]"></app-detail>
                  <app-detail *ngIf="noteObject?.partner?.shortName" header="Partner" [value]="noteObject?.partner?.shortName" [link]="['/partnerzy/szczegoly', noteObject?.partner?.uuid]"></app-detail>
                  <app-detail *ngIf="noteObject?.notePartnerOfwcas.length" header="OFWCA">
                    <mat-chip-list>
                      <ng-container *ngFor="let notePartnerOfwcas of noteObject.notePartnerOfwcas">
                        <mat-chip color="accent" selected>
                          {{ notePartnerOfwcas.fullName }}
                        </mat-chip>
                      </ng-container>
                    </mat-chip-list>
                  </app-detail>
                  <app-detail *ngIf="noteObject?.partnerOutsideStructure" header="Partner spoza struktury" [value]="noteObject?.partnerOutsideStructure"></app-detail>
                  <app-detail *ngIf="noteObject?.facility && noteObject?.verificationSalesProcess === false" style="margin-bottom: 20px;"
                              fxLayoutAlign="start" header="Placówka"
                              [value]="noteObject.facility?.address?.searchString"
                              [link]="noteObject.facility ? ['/placowki/szczegoly', noteObject.facility?.address?.uuid] : undefined">
                  </app-detail>
                  <app-detail-bool header="Spotkanie odwołane" [value]="noteObject?.tookPlace"></app-detail-bool>
                </div>
              </mat-card>

            <mat-card class="note-grid-item">
              <app-detail fxLayoutAlign="start" header="Notatka" [value]="noteObject?.noteData"></app-detail>
            </mat-card>

          </div>
        <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

            <mat-card class="checkboxy">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start" style="width: 100%;">
                  <app-detail-bool header="Weryfikacja procesu sprzedaży" [value]="noteObject?.verificationSalesProcess"></app-detail-bool>
                  <app-detail-bool header="Wyniki" [value]="noteObject?.results"></app-detail-bool>
                  <app-detail-bool header="Szkolenie" [value]="noteObject?.training"></app-detail-bool>
                  <app-detail-bool header="Relacje" [value]="noteObject?.relations"></app-detail-bool>
                  <app-detail-bool header="Kontrola" [value]="noteObject?.control"></app-detail-bool>
                  <app-detail-bool header="Rekrutacja" [value]="!!noteObject?.recruitment"></app-detail-bool> <app-detail-bool header="Inne" [value]="!!noteObject?.other"></app-detail-bool> </div>
                <app-detail *ngIf="noteObject?.other" fxFlex="100" class="limited-height" header="Inne" [value]="noteObject?.other"></app-detail>
              </div>
            </mat-card>
          <mat-card class="note-grid-item" *ngIf="noteObject?.facility && noteObject.verificationSalesProcess">
              Weryfikacja procesu sprzedaży
            <app-detail style="margin-bottom: 20px;"
                  fxLayoutAlign="start" header="Placówka"
                  [value]="noteObject.facility?.address?.searchString"
                  [link]="noteObject.facility ? ['/placowki/szczegoly', noteObject.facility?.address?.uuid] : undefined">
            </app-detail>
              <div fxLayout="row" fxLayoutGap="15px">
                <button *ngIf="noteObject?.verificationSales" mat-raised-button fxFlex="33" [ngClass]="noteObject?.verificationSales.status?.color + '-button'">
                  {{noteObject?.verificationSales.status?.name}}
                </button>
                <button *ngIf="noteObject?.verificationSales" mat-stroked-button fxFlex="33" color="accent" (click)="downloadCertificates()">
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>
                <button *ngIf="noteObject?.verificationSales" mat-stroked-button fxFlex="33" color="accent" (click)="addDocument()">
                  <mat-icon>post_add</mat-icon>
                </button>
              </div>
          </mat-card>
        </div>
      </div>
  </div>
</form>
</mat-card>
